var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTooltip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-4{fill:none;}.cls-2{fill:#f29b94;}.cls-3{clip-path:url(#clip-path);}.cls-4{stroke:#f29b94;stroke-miterlimit:5;stroke-width:4px;}.cls-5{clip-path:url(#clip-path-2);}.cls-6{clip-path:url(#clip-path-3);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12,
    cy: 12,
    r: 10
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11,
    y: 7,
    width: 2,
    height: 6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11,
    y: 15,
    width: 2,
    height: 2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 12,
    cy: 12,
    r: 10
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11,
    y: 7,
    width: 2,
    height: 6
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 10,
    y: 6,
    width: 4,
    height: 8
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11,
    y: 15,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 10,
    y: 14,
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 24,
    height: 24
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.a1d579ffb9286b6183cd7519b3132ac4.svg";
export { ForwardRef as ReactComponent };